import { useMemo } from 'react';
import { CorporateHealthQuote } from '@models/CorporateHealthQuote';
import { mergeInitialValues } from '@utils/formik';
import { useFormSchema, useFormValues } from '../CorporateHealthQuoteBuyForm';

export const useInitialValues = (corporateHealthQuote?: CorporateHealthQuote | null) => {
  const values = useFormValues();
  return useMemo(() => {
    if (corporateHealthQuote) return mergeInitialValues(values, { ...corporateHealthQuote, proof: undefined, mobileNumber: corporateHealthQuote.user.mobileNumber });
    return values;
  }, [corporateHealthQuote]);
};

export const useValidationSchema = () => {
  const schema = useFormSchema();
  return schema.shape({
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    proof: schema.fields.proof.optional()
  });
};
